import { Dispatch, ReactNode, createContext, useState } from "react";
import { OrdenCompraCard } from "types/OC";

interface OrdenCompraSelectedContextProps {
  forceUpDate: boolean;
  setForceUpDate: Dispatch<React.SetStateAction<boolean>>;
  ordenCompraSelected: OrdenCompraCard;
  setOrdenCompraSelected: Dispatch<React.SetStateAction<OrdenCompraCard>>;
  showNotification: boolean;
  setShowNotification: Dispatch<React.SetStateAction<boolean>>;
  ordenesCompraSelected: OrdenCompraCard[];
  setOrdenesCompraSelected: Dispatch<React.SetStateAction<OrdenCompraCard[]>>;
  companiesFilter: string | null;
  setCompaniesFilter: Dispatch<React.SetStateAction<string | null>>;
  supplierFilter: string | null;
  setSupplierFilter: Dispatch<React.SetStateAction<string | null>>;
  onOrdenAutorizada?: () => void;
}

export const OrdenCompraSelected =
  createContext<OrdenCompraSelectedContextProps>({
    forceUpDate: false,
    setForceUpDate: () => {},
    ordenCompraSelected: {} as OrdenCompraCard,
    setOrdenCompraSelected: () => {},
    showNotification: false,
    setShowNotification: () => {},
    ordenesCompraSelected: [], // Initialize as empty array
    setOrdenesCompraSelected: () => [],
    companiesFilter: null,
    setCompaniesFilter: () => {},
    supplierFilter: null,
    setSupplierFilter: () => {},
    onOrdenAutorizada: () => {},
  });

interface OrdenCompraSelectedProviderProps {
  children: ReactNode;
  onOrdenAutorizada?: () => void;
}

/**
 * Creates a provider component for OrdenCompraSelected, providing state and functions to its children.
 *
 * @param {OrdenCompraSelectedProviderProps} children - The children components to be wrapped by the provider.
 * @return {JSX.Element} The provider component with the provided context value and children.
 */
export const OrdenCompraSelectedProvider = ({
  children,
  onOrdenAutorizada,
}: OrdenCompraSelectedProviderProps) => {
  const [ordenCompraSelected, setOrdenCompraSelected] = useState(
    {} as OrdenCompraCard
  );
  const [ordenesCompraSelected, setOrdenesCompraSelected] = useState<
    OrdenCompraCard[]
  >([]);

  const [forceUpDate, setForceUpDate] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [companiesFilter, setCompaniesFilter] = useState<string | null>(null);
  const [supplierFilter, setSupplierFilter] = useState<string | null>(null);

  return (
    <OrdenCompraSelected.Provider
      value={{
        forceUpDate,
        setForceUpDate,
        ordenCompraSelected,
        setOrdenCompraSelected,
        showNotification,
        setShowNotification,
        ordenesCompraSelected,
        setOrdenesCompraSelected,
        companiesFilter,
        setCompaniesFilter,
        supplierFilter,
        setSupplierFilter,
        onOrdenAutorizada,
      }}
    >
      {children}
    </OrdenCompraSelected.Provider>
  );
};
